import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { carrierService } from '../../services/carrierService';

const CarrierSchema = Yup.object().shape({
  name: Yup.string().required('Taşıyıcı adı zorunludur'),
  email: Yup.string().email('Geçerli bir e-posta adresi giriniz'),
  phone: Yup.string(),
  address: Yup.string(),
  contactPerson: Yup.string(),
  carrierCode: Yup.string().required('Taşıyıcı kodu zorunludur'),
  isActive: Yup.boolean()
});

const CarrierCreate = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialValues = {
    name: '',
    email: '',
    phone: '',
    address: '',
    contactPerson: '',
    carrierCode: '',
    isActive: true
  };

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await carrierService.createCarrier(values);
      toast.success('Taşıyıcı başarıyla oluşturuldu');
      navigate('/carriers');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Taşıyıcı oluşturulurken bir hata oluştu');
      console.error('Error creating carrier:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="pb-5 border-b border-gray-200">
        <h1 className="text-2xl font-semibold text-gray-900">Yeni Taşıyıcı Ekle</h1>
      </div>

      <div className="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <Formik
          initialValues={initialValues}
          validationSchema={CarrierSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <Form className="space-y-6">
              <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div className="sm:col-span-3">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                    Taşıyıcı Adı *
                  </label>
                  <div className="mt-1">
                    <Field
                      type="text"
                      name="name"
                      id="name"
                      className={`shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md ${
                        errors.name && touched.name ? 'border-red-500' : ''
                      }`}
                    />
                    <ErrorMessage name="name" component="div" className="mt-1 text-sm text-red-600" />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label htmlFor="carrierCode" className="block text-sm font-medium text-gray-700">
                    Taşıyıcı Kodu *
                  </label>
                  <div className="mt-1">
                    <Field
                      type="text"
                      name="carrierCode"
                      id="carrierCode"
                      className={`shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md ${
                        errors.carrierCode && touched.carrierCode ? 'border-red-500' : ''
                      }`}
                    />
                    <ErrorMessage name="carrierCode" component="div" className="mt-1 text-sm text-red-600" />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    E-posta
                  </label>
                  <div className="mt-1">
                    <Field
                      type="email"
                      name="email"
                      id="email"
                      className={`shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md ${
                        errors.email && touched.email ? 'border-red-500' : ''
                      }`}
                    />
                    <ErrorMessage name="email" component="div" className="mt-1 text-sm text-red-600" />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                    Telefon
                  </label>
                  <div className="mt-1">
                    <Field
                      type="text"
                      name="phone"
                      id="phone"
                      className="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label htmlFor="contactPerson" className="block text-sm font-medium text-gray-700">
                    İletişim Kişisi
                  </label>
                  <div className="mt-1">
                    <Field
                      type="text"
                      name="contactPerson"
                      id="contactPerson"
                      className="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label htmlFor="isActive" className="block text-sm font-medium text-gray-700">
                    Durum
                  </label>
                  <div className="mt-1">
                    <Field
                      as="select"
                      name="isActive"
                      id="isActive"
                      className="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    >
                      <option value={true}>Aktif</option>
                      <option value={false}>Pasif</option>
                    </Field>
                  </div>
                </div>

                <div className="sm:col-span-6">
                  <label htmlFor="address" className="block text-sm font-medium text-gray-700">
                    Adres
                  </label>
                  <div className="mt-1">
                    <Field
                      as="textarea"
                      name="address"
                      id="address"
                      rows={3}
                      className="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => navigate('/carriers')}
                  className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 ${
                    isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                >
                  {isSubmitting ? 'Kaydediliyor...' : 'Kaydet'}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CarrierCreate;
